import { Fragment, useEffect, useState } from "react";
import { Text, Avatar, DataList } from "@radix-ui/themes";
import Container from "@/components/atoms/Container";
import GlobalTabs from "@/components/organisms/Global/Tabs/Index";
import useMessageProps from "@/hooks/useMessageProps";
import useAccess from "@/hooks/useAccess";
import StandardBreadcrumb from "@/components/molecules/StandardBreadcrumb";
import { router } from "@inertiajs/react";

type Props = {
  [key: string]: any;
};

const Index = ({ ...props }: Props) => {
  console.log(props);
  const [isActionTab, setIsActionTab] = useState(true);
  const { getAccess } = useAccess();
  const breadcrumbItems = [
    {
      label: "Globals",
      onClick: () => router.get("/globals"),
    }
  ];

  useMessageProps(props);

  return (
    <div>
      <Container>
        <StandardBreadcrumb items={breadcrumbItems} />
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-center gap-2">
            <Text size="6">Global Models</Text>
          </div>
        </div>
      </Container>

      <GlobalTabs
        props={props}
        onTabChange={(tab) => {
          setIsActionTab(tab as any);
        }}
      />
    </div>
  );
};

export default Index;
